/**
 * API origin resolution (matches pre-segregation desktop behaviour, adapted for split envs):
 *
 * - **Desktop installer** (CI): `VITE_API_URL` baked via `.env.production.local`
 *   (beta → dev.app.hria.edu.pk, stable → app.hria.edu.pk).
 * - **Packaged Electron fallback**: preload exposes `electronAPI.apiBaseUrl` from shell `.env`.
 * - **Web UI** (deploy-server): empty `VITE_API_URL` → same-origin on prod/dev host.
 */
export function getApiBaseUrl(): string {
  const envUrl = (import.meta as ImportMeta & { env?: { VITE_API_URL?: string } }).env?.VITE_API_URL;
  if (envUrl?.trim()) return envUrl.replace(/\/$/, '');

  type ElectronAPI = { apiBaseUrl?: string };
  const electron =
    typeof window !== 'undefined'
      ? (window as Window & { electronAPI?: ElectronAPI }).electronAPI
      : undefined;
  if (electron?.apiBaseUrl?.trim()) {
    return electron.apiBaseUrl.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && /^https?:/.test(window.location.protocol)) {
    return window.location.origin;
  }

  return 'http://localhost:3001';
}
